var map = {
	"./20231026_Verkiezingen-Fela-01.mp3": 8043,
	"./20231026_Verkiezingen-Fela-02.mp3": 3348,
	"./20231026_Verkiezingen-Fela-03.mp3": 3193,
	"./20231026_Verkiezingen-Fela-04.mp3": 2922,
	"./20231026_Verkiezingen-Fela-05.mp3": 6975,
	"./20231026_Verkiezingen-Fela-06.mp3": 8200,
	"./20231026_Verkiezingen-Fela-07.mp3": 925,
	"./20231026_Verkiezingen-Fela-08.mp3": 830,
	"./20231026_Verkiezingen-Fela-09.mp3": 2771,
	"./20231026_Verkiezingen-Fela-10.mp3": 5853,
	"./20231026_Verkiezingen-Fela-11.mp3": 4776,
	"./20231026_Verkiezingen-Fela-12.mp3": 5919,
	"./20231026_Verkiezingen-Fela-13.mp3": 2954,
	"./20231026_Verkiezingen-Fela-14.mp3": 185,
	"./Audio1-2.mp3": 4639,
	"./Audio2-2.mp3": 7403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6408;